import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
    dispatchResetModalReducer: () => ({}),
    dispatchChangeReportOperationReason: (reasonId: string) => ( reasonId ),
});
